<div class="redirect-wrapper">
  <mat-card class="redirect-card">
    <mat-card-content class="redirect-content">
      <mat-spinner diameter="48" />
      <div class="redirect-text">
        <div class="redirect-title">{{ 'redirect.title' | translate }}</div>
        <div class="redirect-subtitle">{{ 'redirect.subtitle' | translate }}</div>
        <span class="redirect-email">{{ user?.email }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</div>
